/**
 * iter75 Phase 2 — Inventory Hub tab registry.
 *
 * Customer Equipment is intentionally NOT here — it belongs to the Customer tabs bar (per user's
 * iter75 spec: equipment is customer-owned history, not NexFlow stock).
 */
import { ShoppingCart, History, ClipboardList,
  Boxes, Package, Building2, Layers, ArrowLeftRight, Archive, BookOpen, Barcode, Truck,
} from 'lucide-react';

const ADMIN_TIER = new Set(['super_admin', 'admin']);
const ALL_INTERNAL = new Set([...ADMIN_TIER, 'service_manager', 'construction_manager', 'office_staff', 'manager']);

export const INVENTORY_HUB_BASE = '/admin/inventory-hub';

export const INVENTORY_TABS = [
  { key: 'inv-v2',         label: 'Inventory Overview',  icon: Boxes,         path: '/admin/inventory-hub/inv-v2',         allow: ALL_INTERNAL },
  { key: 'master',         label: 'Master Inventory',    icon: Package,       path: '/admin/inventory-hub/master',         allow: ALL_INTERNAL },
  { key: 'locations',      label: 'Locations',           icon: Building2,     path: '/admin/inventory-hub/locations',      allow: ADMIN_TIER },
  { key: 'stock',          label: 'Stock by Location',   icon: Layers,        path: '/admin/inventory-hub/stock',          allow: ALL_INTERNAL },
  { key: 'reorder',        label: 'Reorder List',        icon: ShoppingCart,  path: '/admin/inventory-hub/reorder',        allow: ADMIN_TIER },
  { key: 'supplier-orders', label: 'Supplier Orders',    icon: ClipboardList, path: '/admin/inventory-hub/supplier-orders', allow: ADMIN_TIER },
  { key: 'van-transfers',  label: 'Van Transfer History', icon: History,      path: '/admin/inventory-hub/van-transfers',  allow: ADMIN_TIER },
  { key: 'loadouts',       label: 'Van Loadouts',        icon: Truck,         path: '/admin/inventory-hub/loadouts',       allow: ADMIN_TIER },
  { key: 'transfers',      label: 'Transfers & Requests', icon: ArrowLeftRight, path: '/admin/inventory-hub/transfers',    allow: ALL_INTERNAL },
  { key: 'barcodes',       label: 'Barcodes',            icon: Barcode,       path: '/admin/inventory-hub/barcodes',       allow: ADMIN_TIER },
  // iter324 — retired from navigation (route + data kept; reachable by direct link only).
  { key: 'legacy',         label: 'Inventory (legacy)',  icon: Archive,       path: '/admin/inventory-hub/legacy',         allow: ALL_INTERNAL, hidden: true },
  { key: 'knowledge-base', label: 'Knowledge Base',      icon: BookOpen,      path: '/admin/inventory-hub/knowledge-base', allow: ALL_INTERNAL },
];

export const INVENTORY_LEGACY_REDIRECTS = [
  { from: '/admin/inv/dashboard',  to: '/admin/inventory-hub/inv-v2' },
  { from: '/admin/inv/items',      to: '/admin/inventory-hub/master' },
  { from: '/admin/inv/locations',  to: '/admin/inventory-hub/locations' },
  { from: '/admin/inv/stock',      to: '/admin/inventory-hub/stock' },
  { from: '/admin/inv/workflow',   to: '/admin/inventory-hub/transfers' },
  { from: '/admin/inv/transfers',  to: '/admin/inventory-hub/transfers' },
  { from: '/admin/inv/material-requests',  to: '/admin/inventory-hub/transfers' },
  { from: '/admin/inv/new-item-requests',  to: '/admin/inventory-hub/transfers' },
  { from: '/admin/inventory',      to: '/admin/inventory-hub/legacy' },
  { from: '/admin/knowledge-base', to: '/admin/inventory-hub/knowledge-base' },
];
